import { render, staticRenderFns } from "./NotificationsPrompt.vue?vue&type=template&id=576d391b"
import script from "./NotificationsPrompt.vue?vue&type=script&lang=js"
export * from "./NotificationsPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports